import React from 'react';

import component, {classnames} from './component';
import Link from './Link';
import {ArrowRight} from './icons';

// TODO should join with DataEditButton, rename it to EditButton or just Button
// and pull link up from the component, no reason for it to be here

export default component('LinkButton', function({data, className, name, params, text, onClick}) {

  if (name) {
    return (
      <Link className={className} name={name} params={params}>
        <div className='LinkButton'>
          <div className='LinkButton-Text'>{text}</div>
          <ArrowRight className='LinkButton-Arrow' />
        </div>
      </Link>
    );
  } else if (onClick) {
    return (
      <div className={classnames('LinkButton', className)} onClick={onClick}>
        <div className='LinkButton-Text'>{text}</div>
        <ArrowRight className='LinkButton-Arrow' />
      </div>
    );
  } else {
    return null;
  }

});



// WEBPACK FOOTER //
// ./src/components/LinkButton.js